export default "__VITE_ASSET__DSxRT7eK__"